function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1387_9085)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M65.5 43.46C65.57 43.5 101.6 22.7 101.6 22.7L92.61 17.5H128.58V38.26L119.7 32.96L83.55 53.88L65.5 43.46Z",
  fill: "white",
  stroke: "#002556",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_1387_9085)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M94.4407 121.57L105.551 115.53C107.171 114.53 108.181 112.35 108.171 109.28L108.031 63.33C108.011 57.43 104.261 50.5 99.6507 47.84L19.4507 1.53999C17.5107 0.419992 15.7307 0.239992 14.3307 0.839992L3.2207 6.88999",
  fill: "#E3E5E8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.4407 121.57L105.551 115.53C107.171 114.53 108.181 112.35 108.171 109.28L108.031 63.33C108.011 57.43 104.261 50.5 99.6507 47.84L19.4507 1.53999C17.5107 0.419992 15.7307 0.239992 14.3307 0.839992L3.2207 6.88999",
  stroke: "#002556",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.3703 69.1501L97.5103 115.1C97.5303 120.97 93.8203 123.58 89.2203 120.93L9.19032 74.7301C4.59032 72.0801 0.84032 65.1601 0.80032 59.2701L0.50032 13.2301C0.46032 7.32014 4.17032 4.69014 8.77032 7.35014L88.9903 53.6601C93.6003 56.3201 97.3503 63.2601 97.3703 69.1501Z",
  fill: "white",
  stroke: "#002556",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.740313 49.26L4.02031 48.35C5.19031 48.03 5.88031 46.75 5.87031 44.94L5.80031 33.58C5.79031 31.77 5.07031 29.67 3.89031 27.99L0.570312 23.27L0.740313 49.26Z",
  fill: "#002556",
  stroke: "#002556",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.2911 101.93C88.3111 106.99 85.0811 109.26 81.1211 106.98L88.2911 101.93Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.2911 101.93C88.3111 106.99 85.0811 109.26 81.1211 106.98",
  stroke: "#002556",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.9395 58.3301C84.9095 60.6201 88.1695 66.6501 88.1895 71.7301L80.9395 58.3301Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.9395 58.3301C84.9095 60.6201 88.1695 66.6501 88.1895 71.7301",
  stroke: "#002556",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.2912 30.22C16.2612 25.14 19.4812 22.85 23.4512 25.14L16.2912 30.22Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.2912 30.22C16.2612 25.14 19.4812 22.85 23.4512 25.14",
  stroke: "#002556",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.7307 73.84C19.7707 71.55 16.5007 65.53 16.4707 60.46L23.7307 73.84Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.7307 73.84C19.7707 71.55 16.5007 65.53 16.4707 60.46",
  stroke: "#002556",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.5901 54.0303L41.3301 68.1403",
  stroke: "#002556",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.1311 54.4302L49.8711 68.5402",
  stroke: "#002556",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.9609 65.0303L48.7109 79.1403",
  stroke: "#002556",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.4202 63.0503L54.1602 77.1603",
  stroke: "#002556",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.3108 69.2803L56.0508 83.3803",
  stroke: "#002556",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.2095 48.46L41.5195 77.03",
  stroke: "#002556",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.3896 15.9102L19.3096 9.51017C18.2496 8.90017 18.2196 7.91017 19.2396 7.32017C20.2696 6.73017 21.9796 6.74017 23.0496 7.36017L34.1696 13.7802C35.2396 14.4002 35.2496 15.3802 34.2096 15.9602C33.1696 16.5402 31.4496 16.5202 30.3896 15.9102Z",
  fill: "#002556",
  stroke: "#002556",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 98,
  width: 24,
  height: 24,
  rx: 12,
  fill: "#007BFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.1059 104.3V115.5H12.6419V106.86L10.4339 107.772V105.596L13.5539 104.3H15.1059Z",
  fill: "white"
}));
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1387_9085"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64.08,
  height: 37.38,
  fill: "white",
  transform: "translate(65 17)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_1387_9085"
}, /*#__PURE__*/React.createElement("rect", {
  width: 108.68,
  height: 122.47,
  fill: "white"
})));
function SvgInstrFirstCapture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstrFirstCapture);
export default __webpack_public_path__ + "static/media/instr-first-capture.c72cfd0634c2031f72c3b9ada73e7a9c.svg";
export { ForwardRef as ReactComponent };